export const freeDiabetesMedIds = [
  '167529',
  '204311',
  '163934',
  '155744',
  '241223',
  '191479',
  '281538',
  '154757',
  '195978',
  '297705',
  '261972',
  '281055',
  '293032',
  '183692',
  '272241',
  '235788',
];
export const isFreeDiabetesMedication = (medId: string): boolean => freeDiabetesMedIds.includes(medId);
